import { Breadcrumb } from "@gull";
import { logoFetch, logoUpload } from "app/services/bannerSettingService";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { NotificationManager } from "react-notifications";

export default function LogoUpload() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileSizeError, setFileSizeError] = useState("");
  const handleFileChange = (event) => {
    setFileSizeError("");
    const file = event.target.files[0];
    const maxSize = 3 * 1024 * 1024; // 5MB
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];

    if (file) {
      let errorMessage = "";

      // Check file size
      if (file.size >= maxSize) {
        errorMessage = "File size exceeds 3MB.";
      }

      // Check file type
      if (!allowedTypes.includes(file.type)) {
        errorMessage += (errorMessage ? " " : "") + "File not supported.";
      }

      if (errorMessage) {
        setFileSizeError(errorMessage);
      } else {
        setFileSizeError("");
        setSelectedFile(file);
      }
    }
  };

  const handleUpload = async () => {
    // Perform upload logic with selectedFile

    try {
      if (selectedFile) {
        let formData = new FormData();
        formData.append("merchantLogo", selectedFile);
        debugger;
        const result = await logoUpload(formData);
        // console.log(result);
        if (result.status == "Success") {
          NotificationManager.success(result.message);
          userLogoCode();
          setSelectedFile(null);
          formData.append("merchantLogo", selectedFile);
        } else {
          NotificationManager.error(result.message);
        }
      } else {
        NotificationManager.error("No file selected.");
      }
    } catch (error) {
      NotificationManager.error("something want to be wrong");
    }
  };
  const [logoState, setLogoState] = useState(null);
  const [logoLoading, setLogoLoading] = useState(false);
  const [logoRefresh, setLogoRefresh] = useState(false);
  const userLogoCode = async () => {
    setLogoRefresh(true);
    setLogoLoading(true);

    try {
      const req = "chandnitravels786";
      const response = await logoFetch(req);

      // Use lowercase fallback
      const contentType =
        response.headers["content-type"] || response.headers["Content-Type"];

      // Convert binary response data to base64 (browser-friendly)
      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );

      const url = `data:${contentType};base64,${base64}`;
      setLogoState(url);
      setLogoRefresh(false);
      setLogoLoading(false);
      setSelectedFile(null);
    } catch (error) {
      setLogoState(null);
      setLogoRefresh(false);
      setLogoLoading(false);
    } finally {
      setLogoLoading(false);
      setLogoRefresh(false);
    }
  };
  useEffect(() => {
    userLogoCode();
  }, []);
  //   useEffect(() => {
  //     userLogoCode();
  //   }, [logoRefresh]);
  return (
    <div>
      <Helmet>
        <title>Company Logo Upload</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Company Logo Upload" }]}
      ></Breadcrumb>

      <div className="mb-3">
        <Row>
          <Col xs={3}>
            <div className="fw-bold">Company Logo Upload:</div>
            <div className="text-primary">
              (ex. File Name .JPEG/.JPG, .PNG, .GIF)
            </div>
          </Col>
          <Col xs={8}>
            <div className="d-flex align-items-center gap-2">
              <input
                type="file"
                id="merchantLogo"
                name="merchantLogo"
                onChange={handleFileChange}
                className="form-control"
              />
              <Button
                onClick={handleUpload}
                disabled={!selectedFile || !!fileSizeError}
              >
                Upload
              </Button>
            </div>
            {fileSizeError && (
              <div
                style={{
                  color: "red",
                  marginTop: "5px",
                }}
              >
                {fileSizeError}
              </div>
            )}
          </Col>
        </Row>
      </div>
      <Container className="py-4">
        <Row className="justify-content-center text-center">
          <Col lg={6} md={8} sm={10} xs={12}>
            <h3 className="mb-3">Current Logo</h3>
            <div
              style={{
                // maxHeight: "200px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "5px",
                backgroundColor: "#f8f8f8",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              {logoLoading ? (
                <p>Loading logo...</p>
              ) : (
                <img
                  src={logoState}
                  alt="logo preview"
                  className="img-fluid"
                  //   style={{
                  //     maxHeight: "200px",
                  //   }}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
